import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, mergeProps as _mergeProps, withCtx as _withCtx, createBlock as _createBlock, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "c-gen-nav__mobile-header" }
const _hoisted_2 = {
  key: 0,
  class: "c-gen-nav__mobile-menus"
}
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  key: 2,
  class: "c-gen-nav__mobile-arrow"
}
const _hoisted_6 = {
  key: 1,
  class: "c-gen-nav__mobile-menus"
}
const _hoisted_7 = { class: "c-gen-nav__mobile-submenu-title" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = {
  key: 2,
  class: "c-gen-nav__mobile-menus"
}
const _hoisted_10 = { class: "c-gen-nav__mobile-submenu-title" }
const _hoisted_11 = { class: "c-gen-nav__mobile-menu-title" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = {
  key: 0,
  class: "c-gen-nav__mobile-l3list"
}

import { ref, watch } from 'vue';
import utils from '@/utils';
import { appendQuery, getBetterUrl } from '@/utils/uri-utils';
import * as querystring from 'querystring';
import { MenuItemFields } from '@/types/components/Header';
import { ScItem } from '@/types/sitecore';
import SiteLink from '@/elements/SiteLink.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'HeaderMobile',
  props: {
    menus: {},
    isOpen: { type: Boolean }
  },
  emits: ['close'],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const activeL2Menu = ref<any>(null);
const activeL3Menu = ref<any>(null);
const expandedL3Item = ref('');

watch(
  () => props.isOpen,
  (newVal) => {
    if (!newVal) {
      activeL2Menu.value = null;
      activeL3Menu.value = null;
      expandedL3Item.value = '';
    }
  }
);

const getCategories = (menu: any) => {
  const f = menu?.fields || menu || {};
  const c = f.categories;
  return Array.isArray(c) ? c : [];
};

const hasCategories = (menu: any) => {
  return getCategories(menu).length > 0;
};

const getItems = (cat: any) => {
  const f = cat?.fields || cat || {};
  const i = f.items;
  return Array.isArray(i) ? i : [];
};

const hasItems = (cat: any) => {
  return getItems(cat).length > 0;
};

const getSubItems = (item: any) => {
  const f = item?.fields || item || {};
  const s = f.subItems;
  return Array.isArray(s) ? s : [];
};

const hasSubItems = (item: any) => {
  return getSubItems(item).length > 0;
};

const getTitle = (item: any) => {
  const title = utils.sc.getFieldObj(item, 'title');
  return title?.value || title || item?.displayName || item?.name || '';
};

const getLinkHref = (item: any) => {
  const link = utils.sc.getFieldObj(item, 'link');
  let url = link?.value?.href || link?.href || '';

  if (!url) return '';
  if (/^(mailto|tel):/gi.test(url)) return url;
  if (/^https?:\/\/((tel|mailto):|#)/gi.test(url)) return url.replace(/^https?:\/\//gi, '');

  const queryString = link?.value?.querystring || link?.querystring;
  if (queryString) {
    try {
      url = appendQuery(url, querystring.parse(queryString));
    } catch (error) {
      console.warn('Failed to parse querystring:', queryString, error);
    }
  }

  const anchor = link?.value?.anchor || link?.anchor;
  if (anchor) {
    url = `${url}?id=${anchor}`;
  }

  return getBetterUrl(url) ?? '';
};

const getLinkAttrs = (item: any) => {
  const link = utils.sc.getFieldObj(item, 'link');
  const value = link?.value || link || {};
  const attrs: Record<string, string> = {};

  if (value.target) attrs.target = value.target;
  if (value.title) attrs.title = value.title;
  if (value.class) attrs.class = value.class;
  if (value.target === '_blank') attrs.rel = 'noopener noreferrer';

  return attrs;
};

const getLinkField = (item: any) => {
  const link = utils.sc.getFieldObj(item, 'link');
  return {
    value: {
      ...(link?.value || link || {}),
      href: link?.value?.href || link?.href || '',
    },
  };
};

const openL2 = (menu: any) => {
  activeL2Menu.value = menu;
  activeL3Menu.value = null;
  expandedL3Item.value = '';
};

const openL3 = (cat: any) => {
  activeL3Menu.value = cat;
};

const toggleL3Item = (item: any) => {
  const title = utils.sc.getFieldValue(item, 'title');
  if (hasSubItems(item)) {
    expandedL3Item.value = expandedL3Item.value === title ? '' : title;
  }
};

return (_ctx: any,_cache: any) => {
  const _component_Icon = _resolveComponent("Icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["c-gen-nav__mobile-drawer", { 'is-open': __props.isOpen }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("button", {
        class: "c-gen-nav__mobile-close",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('close')))
      }, [
        _createVNode(_component_Icon, {
          name: "close",
          class: "c-gen-nav__icon c-gen-nav__icon--large"
        })
      ])
    ]),
    (!activeL2Menu.value && !activeL3Menu.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.menus, (menu, i) => {
            return (_openBlock(), _createElementBlock("div", {
              key: i,
              class: "c-gen-nav__mobile-menu-item"
            }, [
              _createElementVNode("div", {
                class: "c-gen-nav__mobile-menu-title",
                onClick: ($event: any) => (hasCategories(menu) ? openL2(menu) : null)
              }, [
                (hasCategories(menu))
                  ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_unref(utils).sc.getFieldValue(menu, 'title')), 1))
                  : (_openBlock(), _createBlock(SiteLink, _mergeProps({
                      key: 1,
                      link: getLinkField(menu)
                    }, { ref_for: true }, getLinkAttrs(menu)), {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(utils).sc.getFieldValue(menu, 'title')), 1)
                      ]),
                      _: 2
                    }, 1040, ["link"])),
                (hasCategories(menu))
                  ? (_openBlock(), _createElementBlock("span", _hoisted_5, [
                      _createVNode(_component_Icon, {
                        name: "arrow-right",
                        class: "c-gen-nav__icon"
                      })
                    ]))
                  : _createCommentVNode("", true)
              ], 8, _hoisted_3)
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    (activeL2Menu.value && !activeL3Menu.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("button", {
            class: "c-gen-nav__mobile-back",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (activeL2Menu.value = null))
          }, [
            _createVNode(_component_Icon, {
              name: "arrow-left",
              class: "c-gen-nav__icon"
            }),
            _cache[3] || (_cache[3] = _createTextVNode(" Back ", -1))
          ]),
          _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(utils).sc.getFieldValue(activeL2Menu.value, 'title')), 1),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getCategories(activeL2Menu.value), (cat) => {
            return (_openBlock(), _createElementBlock("div", {
              key: _unref(utils).sc.getFieldValue(cat, 'title'),
              class: "c-gen-nav__mobile-menu-item"
            }, [
              _createElementVNode("div", {
                class: _normalizeClass(["c-gen-nav__mobile-menu-title", { 'has-submenu': hasItems(cat) }])
              }, [
                _createVNode(SiteLink, _mergeProps({
                  link: getLinkField(cat)
                }, { ref_for: true }, getLinkAttrs(cat)), {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(getTitle(cat)), 1)
                  ]),
                  _: 2
                }, 1040, ["link"]),
                (hasItems(cat))
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      class: "c-gen-nav__mobile-arrow",
                      type: "button",
                      onClick: _withModifiers(($event: any) => (openL3(cat)), ["stop"])
                    }, [
                      _createVNode(_component_Icon, {
                        name: "arrow-right",
                        class: "c-gen-nav__icon"
                      })
                    ], 8, _hoisted_8))
                  : _createCommentVNode("", true)
              ], 2)
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    (activeL3Menu.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createElementVNode("button", {
            class: "c-gen-nav__mobile-back",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (activeL3Menu.value = null))
          }, [
            _createVNode(_component_Icon, {
              name: "arrow-left",
              class: "c-gen-nav__icon"
            }),
            _cache[4] || (_cache[4] = _createTextVNode(" Back ", -1))
          ]),
          _createElementVNode("div", _hoisted_10, _toDisplayString(_unref(utils).sc.getFieldValue(activeL3Menu.value, 'title')), 1),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getItems(activeL3Menu.value), (item) => {
            return (_openBlock(), _createElementBlock("div", {
              key: _unref(utils).sc.getFieldValue(item, 'title'),
              class: "c-gen-nav__mobile-menu-item"
            }, [
              _createElementVNode("div", _hoisted_11, [
                _createVNode(SiteLink, _mergeProps({
                  class: "c-gen-nav__mobile-link-title",
                  link: getLinkField(item)
                }, { ref_for: true }, getLinkAttrs(item)), {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(getTitle(item)), 1)
                  ]),
                  _: 2
                }, 1040, ["link"]),
                (hasSubItems(item))
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      class: "c-gen-nav__mobile-arrow",
                      type: "button",
                      onClick: _withModifiers(($event: any) => (toggleL3Item(item)), ["stop"])
                    }, [
                      _createVNode(_component_Icon, {
                        name: "arrow-down",
                        class: _normalizeClass(["c-gen-nav__icon", {
                'is-rotated': expandedL3Item.value === _unref(utils).sc.getFieldValue(item, 'title'),
              }])
                      }, null, 8, ["class"])
                    ], 8, _hoisted_12))
                  : _createCommentVNode("", true)
              ]),
              (expandedL3Item.value === _unref(utils).sc.getFieldValue(item, 'title'))
                ? (_openBlock(), _createElementBlock("ul", _hoisted_13, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getSubItems(item), (sub) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: _unref(utils).sc.getFieldValue(sub, 'title')
                      }, [
                        _createVNode(SiteLink, _mergeProps({
                          class: "c-gen-nav__mobile-l3list-title",
                          link: getLinkField(sub)
                        }, { ref_for: true }, getLinkAttrs(sub)), {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(getTitle(sub)), 1)
                          ]),
                          _: 2
                        }, 1040, ["link"])
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})